import { MutationTree } from 'vuex';
import { CustomerState } from '@/store/modules/backoffice/customer/index';
import {
  CUSTOMER_RESET_STATE,
  SET_ALL_CUSTOMERS,
  SET_ALL_CUSTOMERS_ERRORS,
  SET_ALL_OFFICES_BY_CUSTOMER,
  SET_ALL_OFFICES_ERRORS,
  SET_ALL_REMINDERS_BY_CUSTOMER,
  SET_ALL_SECTIONS_BY_OFFICE,
  SET_ALL_SECTIONS_ERRORS,
  SET_CUSTOMER_DETAILS,
  SET_EXPORT_FORM_101_REQUEST_ERRORS,
  SET_MANAGER_PRIVILEGE,
  SET_MANAGER_PRIVILEGES,
  SET_MANAGER_TO_ADD,
  SET_MANAGER_TO_DELETE,
  SET_MANAGER_TO_UPDATE,
  SET_MANAGERS_BY_CUSTOMER,
  SET_OFFICE_DETAILS,
  SET_OPEN_ADD_MANAGER_MODAL,
  SET_OPEN_ADD_MANAGER_MODAL_ERRORS,
  SET_OPEN_CREATE_REMINDERS_MODAL,
  SET_OPEN_CREATE_REMINDERS_MODAL_ERRORS,
  SET_OPEN_DELETE_MANAGER_MODAL,
  SET_OPEN_DELETE_MANAGER_MODAL_ERRORS,
  SET_OPEN_UPDATE_MANAGER_MODAL,
  SET_OPEN_UPDATE_MANAGER_MODAL_ERRORS,
  SET_OPEN_UPLOAD_MANAGER_PRIVILEGES_FILE_MODAL,
  SET_ORG_UNITS,
  SET_UPDATE_CUSTOMER_SETTINGS_MODAL,
  SET_UPDATE_CUSTOMER_SETTINGS_MODAL_ERRORS,
  SET_UPDATE_OFFICE_SETTINGS_MODAL,
  SET_UPDATE_OFFICE_SETTINGS_MODAL_ERRORS,
  SET_UPLOAD_MANAGER_PRIVILEGES_FILE_MODAL_ERRORS,
} from '@/types/customer.types';
import { Grid } from '@/models/Grid.model';
import { CustomerDetailsModel } from '@/models/backoffice/CustomerDetails';
import { initialState } from '@/store/modules/backoffice/customer';
import { ManagerPrivilegesModel } from '@/models/backoffice/ManagerPrivilegesModel';
import { OrganisationUnitModel } from '@/models/backoffice/OrganisationUnitModel';

export const mutations: MutationTree<CustomerState> = {

  [SET_ALL_CUSTOMERS]: (state, allCustomers: Grid) => {
    state.allCustomers = allCustomers;
  },

  [SET_ALL_CUSTOMERS_ERRORS]: (state, allCustomersErrors: string[]) => {
    state.allCustomersErrors = allCustomersErrors;
  },

  [SET_CUSTOMER_DETAILS]: (state, customerDetails: CustomerDetailsModel) => {
    state.customerDetails = customerDetails;
  },

  [SET_UPDATE_CUSTOMER_SETTINGS_MODAL]: (state, updateCustomerSettingsModal: boolean) => {
    state.updateCustomerSettingsModal = updateCustomerSettingsModal;
  },

  [SET_UPDATE_CUSTOMER_SETTINGS_MODAL_ERRORS]: (state, updateCustomerSettingsModalErrors: string[]) => {
    state.updateCustomerSettingsModalErrors = updateCustomerSettingsModalErrors;
  },

  [SET_ALL_OFFICES_BY_CUSTOMER]: (state, allOfficesByCustomer: Grid) => {
    state.allOfficesByCustomer = allOfficesByCustomer;
  },

  [SET_ALL_OFFICES_ERRORS]: (state, allOfficesErrors: string[]) => {
    state.allOfficesErrors = allOfficesErrors;
  },

  [SET_ALL_SECTIONS_BY_OFFICE]: (state, allSectionsByOffice: Grid) => {
    state.allSectionsByOffice = allSectionsByOffice;
  },

  [SET_ALL_SECTIONS_ERRORS]: (state, allSectionsErrors: string[]) => {
    state.allSectionsErrors = allSectionsErrors;
  },

  [SET_OFFICE_DETAILS]: (state, officesDetails: CustomerDetailsModel) => {
    state.officeDetails = officesDetails;
  },

  [SET_UPDATE_OFFICE_SETTINGS_MODAL]: (state, updateOfficeSettingsModal: boolean) => {
    state.updateOfficeSettingsModal = updateOfficeSettingsModal;
  },

  [SET_UPDATE_OFFICE_SETTINGS_MODAL_ERRORS]: (state, updateOfficeSettingsModalErrors: string[]) => {
    state.updateOfficeSettingsModalErrors = updateOfficeSettingsModalErrors;
  },

  [SET_ALL_REMINDERS_BY_CUSTOMER]: (state, allRemindersByCustomer: Grid) => {
    state.allRemindersByCustomer = allRemindersByCustomer;
  },

  [SET_OPEN_CREATE_REMINDERS_MODAL]: (state, openCreateRemindersModal: boolean) => {
    state.openCreateRemindersModal = openCreateRemindersModal;
  },

  [SET_OPEN_CREATE_REMINDERS_MODAL_ERRORS]: (state, openCreateRemindersModalErrors: string[]) => {
    state.openCreateRemindersModalErrors = openCreateRemindersModalErrors;
  },

  [SET_MANAGERS_BY_CUSTOMER]: (state, managersByCustomer: Grid) => {
    state.managersByCustomer = managersByCustomer;
  },

  [SET_MANAGER_TO_ADD]: (state, managerToAdd: Grid) => {
    state.managerToAdd = managerToAdd;
  },

  [SET_MANAGER_TO_DELETE]: (state, managerToDelete: ManagerPrivilegesModel | null) => {
    state.managerToDelete = managerToDelete;
  },

  [SET_OPEN_DELETE_MANAGER_MODAL]: (state, openDeleteManagerModal: boolean) => {
    state.openDeleteManagerModal = openDeleteManagerModal;
  },

  [SET_OPEN_DELETE_MANAGER_MODAL_ERRORS]: (state, openDeleteManagerModalErrors: string[]) => {
    state.openDeleteManagerModalErrors = openDeleteManagerModalErrors;
  },

  [SET_MANAGER_TO_UPDATE]: (state, managerToUpdate: ManagerPrivilegesModel | null) => {
    state.managerToUpdate = managerToUpdate;
  },

  [SET_OPEN_UPDATE_MANAGER_MODAL]: (state, openUpdateManagerModal: boolean) => {
    state.openUpdateManagerModal = openUpdateManagerModal;
  },

  [SET_OPEN_UPDATE_MANAGER_MODAL_ERRORS]: (state, openUpdateManagerModalErrors: string[]) => {
    state.openUpdateManagerModalErrors = openUpdateManagerModalErrors;
  },

  [SET_OPEN_UPLOAD_MANAGER_PRIVILEGES_FILE_MODAL]: (state, openUploadManagerPrivilegesModal: boolean) => {
    state.openUploadManagerPrivilegesModal = openUploadManagerPrivilegesModal;
  },

  [SET_UPLOAD_MANAGER_PRIVILEGES_FILE_MODAL_ERRORS]: (state, openUploadManagerPrivilegesModalErrors: string[]) => {
    state.openUploadManagerPrivilegesModalErrors = openUploadManagerPrivilegesModalErrors;
  },

  [SET_OPEN_ADD_MANAGER_MODAL]: (state, openAddManagerModal: boolean) => {
    state.openAddManagerModal = openAddManagerModal;
  },

  [SET_OPEN_ADD_MANAGER_MODAL_ERRORS]: (state, openAddManagerModalErrors: string[]) => {
    state.openAddManagerModalErrors = openAddManagerModalErrors;
  },

  [SET_ORG_UNITS]: (state, orgUnits: OrganisationUnitModel) => {
    if (orgUnits) {
      if (state.orgUnits.length) {
        const updatedOrgUnits = [...state.orgUnits];
        updatedOrgUnits[orgUnits.index] = orgUnits;
        state.orgUnits = updatedOrgUnits;
      } else {
        state.orgUnits = [orgUnits];
      }
    } else {
      state.orgUnits = [];
    }
  },

  [SET_MANAGER_PRIVILEGES]: (state, managerPrivileges: any) => {
    state.managerPrivileges = managerPrivileges;
  },

  [SET_MANAGER_PRIVILEGE]: (state, { value, index, property }: any) => {
    const updatedChild = { ...state.managerPrivileges.userOrgPrivileges[index] };
    updatedChild[property] = value;

    const updatedChildren = [...state.managerPrivileges.userOrgPrivileges];
    updatedChildren[index] = updatedChild;
    state.managerPrivileges = ({ ...state.managerPrivileges, userOrgPrivileges: updatedChildren });
  },

  [CUSTOMER_RESET_STATE]: (state) => {
    state = Object.assign(state, initialState());
  },

  [SET_EXPORT_FORM_101_REQUEST_ERRORS]: (state, exportForm101Errors: string[]) => {
    state.exportForm101Errors = exportForm101Errors;
  },
};
